import { useContext } from "react";
import { ConfigContext } from "../providers/ConfigContext";
import useMakeApiRequest from "./useMakeApiRequest";

const useGetRecaptcha = () => {
  const { apiBase } = useContext(ConfigContext);
  const makeApiRequest = useMakeApiRequest("GET");

  const getCaptcha = async (token: any) => await makeApiRequest(`${apiBase}/api/recaptcha/verify?captchaToken=${token}`, {});

  return [getCaptcha];
};

export default useGetRecaptcha;
